import ThemeTable from './container';

export default ThemeTable;



// WEBPACK FOOTER //
// ./src/routes/ThemeTable/index.js